(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerByUser', CustomerByUser);

    CustomerByUser.$inject = ['$resource'];

    function CustomerByUser ($resource) {
        var resourceUrl =  'api/customers/userid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
